export class UserFormController {
    constructor($scope, $state, $stateParams, UsersDao, XRayUIModelSaver, TOOLTIPS, $timeout) {
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.usersDao = UsersDao;
        this.$timeout = $timeout;
        this.TOOLTIP = TOOLTIPS.admin.users;

        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;

        this.modelSaver = XRayUIModelSaver.createInstance(this, ['userData']);
        this.modelSaver.onStateChangeCancel = () => {
            $scope.$parent.Settings.syncTabsWithState();
        };


        this.input = {};

        if (this.$stateParams.userName) {
            this.mode = 'edit';
            this.title = 'Edit User "' + this.$stateParams.userName + '"';
            $scope.$parent.Settings.saveButtonText = "Save";
            this.getUserData();
        }
        else {
            this.mode = 'new';
            this.title = 'New User';
            $scope.$parent.Settings.saveButtonText = "Create";
        }
        this.passwordRank = 0;
    }

    getUserData() {
        this.usersDao.getOne({username: this.$stateParams.userName}).$promise.then((user) => {
//            console.log(user);
            this.userData = user;
            this.modelSaver.save();
        })
    }


    save() {
        let promise;
        let payload = _.cloneDeep(this.userData);
//        console.log(this.userData);
        if (this.input.password) {
            payload.password = this.input.password;
        }
        else {
            delete payload.password;
        }

        if (this.mode === 'new') {
            promise = this.usersDao.create(payload).$promise;
        }
        else {
            delete payload.name;
            promise = this.usersDao.update({username: this.$stateParams.userName}, payload).$promise;
        }
        promise.then((res) => {

            this.modelSaver.save();
            if (res.status !== 409)
            this.$state.go('settings.users');
        });
    }

    cancel() {
        this.$state.go('settings.users');
    }

    checkPwdMatch(retypeVal) {
        return !retypeVal || (retypeVal && this.input.password === retypeVal);
    }

    checkPwdLevel(retypeVal) {
        let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])");
        if (!retypeVal) {
            return true
        }
        if (strongRegex.test(retypeVal) && retypeVal.length >= 8) {

        } else {
            this.$timeout(() => {
                this.passwordRank = 20;
            })

        }
	    return strongRegex.test(retypeVal) && retypeVal.length >= 8;
    }

    hasWhiteSpace(val) {
        if (val) {
            return val.indexOf(" ") > -1
        }
        return false;
    }

    hasSpecialCharacter(val){
        if(val){
            return /[:+\^*$&%@=<>!?|\/~\\"\.]/.test(val)
        }
    }

    checkEmail(retypeVal) {
        let emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return emailRegex.test(retypeVal);
    }

    canSave() {
        return this.userForm && this.userForm.$valid && !this.hasWhiteSpace();
    }

}


// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/users/user_form.controller.js